const movementEvent = {
  acknowledgedInfractionBalanceBlock: 'acknowledged_infraction_balance_block',
  disagreedInfractionBalanceUnlock: 'disagreed_infraction_balance_unlock',
  expiredInfractionBalanceUnlock: 'expired_infraction_balance_unlock',
  cancelledInfractionBalanceUnlock: 'cancelled_infraction_balance_unlock',
  automaticBalanceBlock: 'automatic_balance_block'
};

module.exports = movementEvent;
